import { apiRequest } from './client';

/** Matches `PatientDeliveryAddressResponse` from the admin API (no `patient_id`). */
export type PatientDeliveryAddressResponse = {
  readonly id: string;
  readonly shipping_method: 'nova_poshta' | 'ukrposhta' | 'international';
  readonly country: string;
  readonly city: string;
  readonly street: string | null;
  readonly house_number: string | null;
  readonly apartment_number: string | null;
  readonly postal_code: string | null;
  readonly recipient_name: string;
  readonly recipient_phone: string;
  readonly is_default: boolean;
  readonly np_settlement_id: string | null;
  readonly np_settlement_name: string | null;
  readonly np_division_id: string | null;
  readonly np_division_name: string | null;
  readonly np_division_number: string | null;
  readonly created_at: string;
  readonly updated_at: string;
};

export function listPatientDeliveryAddresses(
  patientId: string,
  accessToken: string,
): Promise<readonly PatientDeliveryAddressResponse[]> {
  return apiRequest<readonly PatientDeliveryAddressResponse[]>(
    `/admin/patients/${patientId}/delivery-addresses`,
    { method: 'GET', token: accessToken },
  );
}
